import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { styles } from '../../constants';

import { Button, Text, Form, Item, Label, Input, H3, Content, CardItem, Card } from "native-base";
import {
    sendLogin,
    setCurrentAction
} from '../../actions/';

class Login extends Component {
    //wexes@yandex.kz
    // 1234567
    state = {
        // email: "wexes@yandex.ua",
        // password: "1234567",
        email: "",
        password: "",
        hidden: true
    }

    onChangeInput = (key, e) => this.setState({ [key]: e.target.value });
    onChangePass = e => this.setState({ password: e.target.value });

    handlerSubmit = () => {
        const { dispatch } = this.props;
        dispatch(sendLogin(this.state));
    };

    handlerClickRegistration = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('registration'));
    };

    handlerClickEmailConfirm = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('confirm'));
    };

    render() {
        const { authCause } = this.props;
        const { email, password } = this.state;

        return <Content style={styles.content}>
            <Form>
                <H3 style={styles.appDescription}>Вход</H3>
                <Item stackedLabel>
                    <Label>Email*</Label>
                    <Input
                        keyboardType="email-address"
                        onChange={(e) => this.onChangeInput('email', e)}
                        value={email}
                    />
                </Item>
                <Item stackedLabel>
                    <Label>Пароль*</Label>
                    <Input
                        type=""
                        secureTextEntry={true}
                        onChange={this.onChangePass}
                        value={password}
                    />
                </Item>
                <Button
                    large
                    full
                    rounded
                    onPress={this.handlerSubmit}
                    style={styles.button}
                >
                    <Text>Войти</Text>
                </Button>
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickRegistration}>
                    <Text>Регистрация</Text>
                </Button>
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickEmailConfirm}>
                    <Text>Подтверждение электронной почты</Text>
                </Button>
                {authCause ? <Card>
                    <CardItem>
                        <Text>{authCause}</Text>
                    </CardItem>
                </Card> : null}
            </Form>
        </Content>;
    }
}

Login.propTypes = {
    dispatch: PropTypes.func.isRequired,
    authCause: PropTypes.string
};

Login.defaultProps = {
    authCause: ''
};

const mapStateToProps = (state) => ({
    authCause: state.authCause,
    currentAction: state.currentAction
});

export default connect(mapStateToProps)(Login);
